<button class="nav-link btn btn-link btn-sm" (click)="openModal()" title="Change Password" style="color: rgba(255,255,255,.5); padding: 0.5rem 1rem;">
  <i class="fas fa-key"></i> Change Password
</button>

<div class="modal fade show" tabindex="-1" [ngStyle]="{display: show ? 'block' : 'none', background: 'rgba(0,0,0,0.5)'}" *ngIf="show">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Change Password</h5>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="currentPassword">Current Password</label>
            <input 
              type="password" 
              class="form-control" 
              id="currentPassword"
              formControlName="currentPassword"
              [class.is-invalid]="changePasswordForm.get('currentPassword')?.invalid && changePasswordForm.get('currentPassword')?.touched"
            />
            <div class="invalid-feedback" *ngIf="changePasswordForm.get('currentPassword')?.hasError('required') && changePasswordForm.get('currentPassword')?.touched">
              Current password is required
            </div>
          </div>

          <div class="form-group">
            <label for="newPassword">New Password</label>
            <input 
              type="password" 
              class="form-control" 
              id="newPassword"
              formControlName="newPassword"
              [class.is-invalid]="changePasswordForm.get('newPassword')?.invalid && changePasswordForm.get('newPassword')?.touched"
            />
            <small class="form-text text-muted">
              Password must be more than 6 characters, contain at least one number and one special character
            </small>
            <div class="invalid-feedback" *ngIf="passwordError">
              {{ passwordError }}
            </div>
          </div>

          <div class="form-group">
            <label for="confirmPassword">Confirm New Password</label>
            <input 
              type="password" 
              class="form-control" 
              id="confirmPassword"
              formControlName="confirmPassword"
              [class.is-invalid]="changePasswordForm.hasError('passwordMismatch') && changePasswordForm.get('confirmPassword')?.touched"
            />
            <div class="invalid-feedback" *ngIf="confirmPasswordError">
              {{ confirmPasswordError }}
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="changePasswordForm.invalid">Change Password</button>
      </div>
    </div>
  </div>
</div>
